import { Palette } from '@mui/material';

import { PrimarySkillsRanking } from '@constants';

export const rankingDotColor = (
  palette: Palette,
): Record<PrimarySkillsRanking, string> => ({
  [PrimarySkillsRanking.Excellent]: palette.highlight.scoreGreenStrong,
  [PrimarySkillsRanking.VeryGood]: palette.highlight.scoreGreenMid,
  [PrimarySkillsRanking.Good]: palette.highlight.scoreLime,
  [PrimarySkillsRanking.Average]: palette.highlight.scoreYellow,
  [PrimarySkillsRanking.Poor]: palette.highlight.scoreRed,
});
